(function($) {

  /**
   * Copyright 2012, Digital Fusion
   * Licensed under the MIT license.
   * http://teamdf.com/jquery-plugins/license/
   *
   * @author Sam Sehnert
   * @desc A small plugin that checks whether elements are within
   *     the user visible viewport of a web browser.
   *     only accounts for vertical position, not horizontal.
   */

  $.fn.visible = function(partial) {
    
      var $t            = $(this),
          $w            = $(window),
          viewTop       = $w.scrollTop(),
          viewBottom    = viewTop + $w.height(),
          _top          = $t.offset().top,
          _bottom       = _top + $t.height(),
          compareTop    = partial === true ? _bottom : _top,
          compareBottom = partial === true ? _top : _bottom;
    
    return ((compareBottom <= viewBottom) && (compareTop >= viewTop));

  };
    
})(jQuery);

$( document ).ready(function() {

  /*******************************************************************************************************************

  VARIABLES

  *******************************************************************************************************************/
  var images = $('.images-container'),
  loader = $('.loading');
  
  
  
  
  /*******************************************************************************************************************

  GLOBAL FUNCTIONS

  *******************************************************************************************************************/
  images.imagesLoaded( function() {
    console.log('ALL IMAGES HAVE LOADED!!!');
    loader.fadeOut(333);
    startCycle();
  });
  
  function startCycle(){
    console.log('STARTING JQUERY CYCLE!!!');
    images.cycle({ 
      fx:    'fade', 
      speed:  2500 
    });
  }

});